export default "__VITE_ASSET__DNbHQZ2c__"